import { Grid } from "@mui/material";
import FormCard from "./FormCard";

export default function AffectTypes({ setAffectType }) {
  return (
    <>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Ja jestem osobą, która doświadcza mobbingu"
            subtitle="Jestem bezpośrednim uczestnikiem sytuacji, którą chcę zgłosić. Czuję się mobbingowany/a."
            onClick={() => setAffectType(0)}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Nie jestem osobą, która doświadcza mobbingu – zgłaszam go w sprawie innej osoby"
            subtitle="Wiem o sytuacji, którą chcę zgłosić. Uważam, że to inna osoba doznała mobbingu."
            onClick={() => setAffectType(1)}
          />
        </Grid>
      </Grid>
    </>
  );
}
